import {sendWapp} from "../../../Utils/sendWapp";
import PopUp from "../../../PopUp/PopUp";
import {Button} from "../../../Button/Button";
import React, {useContext, useEffect} from "react";
import {useNavigate} from "react-router-dom";
import {ReactComponent as SuccessIcon} from "../../../../assets/systemIcons/success.svg";
import {ReactComponent as WhatsappIcon} from "../../../../assets/systemIcons/whatsapp.svg";
import "./RequestEmissionPopup.css";
import useWindowDimensions from "../../../Utils/useWindowDimensions";
import ClienteDirectoContext from "../../../../context/ClienteDirectoContext";
import {currencyFormat} from "../../../Utils/currencyFormat";
import {ContactText} from "../../../ContactText/ContactText";
import GenericDataContext from "../../../../context/GenericDataContext";

export function RequestEmissionPopup({onClose, product, coverageInfo, isOpen}) {
    const navigate = useNavigate();
    const {datosPolkista, datosMaster} = useContext(ClienteDirectoContext);
    const {polkoClientes} = useContext(GenericDataContext)

    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "";
        }
        return () => {
            document.body.style.overflow = "";
        };
    }, [isOpen]);

    const {width} = useWindowDimensions();
    const isMobile = width <= 480;
    const texts = !isMobile ? {
            contactText: "Contactar por WhatsApp",
            title: "¡Solicitud enviada con éxito!",
        } :
        {
            contactText: "Contactar",
            title: "¡Solicitud exitosa!",
        };
    const productName = {
        vehiculo: "Automotor",
        motovehiculo: "Motovehículo",
    }

    const handleButton = () => {
            polkoClientes ? navigate("/") : window.location.reload();
    }

    const handleWhatsapp = () => {
        sendWapp(`https://api.whatsapp.com/send?phone=${datosPolkista?.Telefono ?? datosMaster?.telefono}&text=Hola,%20estoy%20interesado%20en%20solicitar%20una%20póliza%20de%20seguro%20de%20${productName[product] ?? "Producto no especificado"}.%20Me%20gustaría%20saber%20más,%20me%20podrían%20ayudar? %0ASeleccioné%20la%20cobertura: ${`${coverageInfo?.id} - ${coverageInfo?.nombreCobertura}` ?? "Cobertura no especificada"} de la compañía ${coverageInfo?.compania ?? "Compañia no especificada"}. Cotizada al valor de: ${`$${currencyFormat(coverageInfo?.premium)}` ?? "Precio no especificado"}.`);
    }

    return (
        <PopUp
            size="sm"
            textAlign="left"
            headerColor="green"
            backgroundColor="white"
            title={
                <div className="REPopup__headerInner">
                    <SuccessIcon className="REPopup__icon"/>
                    <h2 className="REPopup__titleText">{texts.title}</h2>
                </div>
            }
            isOpen
            onClose={onClose}
            footer={
                !polkoClientes && (
                    <div className="REPopup__footer">
                        {/* Separador con línea recortada */}
                        <div className="REPopup__separator">
                        <span className="REPopup__urgencyText">
                          ¿Necesitás la póliza con urgencia?
                        </span>
                            <div className="REPopup__divider"/>
                        </div>

                        <div className="REPopup__footerCta">
                            <p className="REPopup__secondaryText">
                                Contactate con nosotros.
                            </p>

                            <Button
                                className="button--large"
                                type="button"
                                onClick={handleWhatsapp}
                                size="fullWidth"
                                color="whatsapp"
                                variant="outlined"
                            >
                                <WhatsappIcon className="REPopup__whatsappIcon"/>
                                {texts.contactText}
                            </Button>
                        </div>
                    </div>
                )
            }
        >
            <div className="REPopup__contentBody">
                <p className="REPopup__mainText">
                    <ContactText withThanks/>
                </p>
                <div className="REPopup__buttonContainer">
                    <Button
                        className="button--large REPopup__primaryButton"
                        type="button"
                        onClick={handleButton}
                        size="fullWidth"
                        color="green"
                    >
                        Volver al inicio
                    </Button>
                    <Button
                        className="button--large REPopup__primaryButton"
                        type="button"
                        onClick={onClose}
                        size="fullWidth"
                        color="primary"
                        variant="outlined"
                    >
                        Explorar otras coberturas
                    </Button>
                </div>

            </div>
        </PopUp>
    )
}